import { EventEmitter } from "events"
const pubsubEvent = new EventEmitter()
export default pubsubEvent
// # sourceMappingURL=event.js.map
